import { render, staticRenderFns } from "./PendingOrderEdit.vue?vue&type=template&id=07c06284&scoped=true"
import script from "./PendingOrderEdit.vue?vue&type=script&lang=js"
export * from "./PendingOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c06284",
  null
  
)

export default component.exports